import * as React from 'react';
import type { GestureResponderEvent } from 'react-native';

/**
 * Will generate the props to open a new URL from the click on a component. This differs from our nagivation hook
 * in how it work with external URLs and will cause a refresh of the page. It is not hooked to our router
 * in any way.
 */
export function useLinkProps(): (
    url?: string,
    sameWebTab?: boolean
) => {
    onPress: (event: GestureResponderEvent) => void;
    href?: string;
    target?: string;
} {
    return React.useCallback(
        (url?: string, sameWebTab?: boolean) => ({
            onPress: (event: GestureResponderEvent) => {
                if (event.isDefaultPrevented() || !url) {
                    return;
                }

                event.preventDefault();

                window.open(
                    url,
                    // @ts-ignore
                    event.nativeEvent.metaKey || event.nativeEvent.ctrlKey || sameWebTab
                        ? undefined
                        : '_blank'
                );
            },
            href: url,
            target: sameWebTab ? undefined : '_blank',
        }),
        []
    );
}
